import { css } from "@emotion/react";
import "~/assets/icomoon/style.css";

import transition from "~/utilities/transition";

export const buttonStyles = ({ theme, isNewsletter }) => css`
    ${isNewsletter
        ? `
        position: absolute;
        top: 0;
        right: 0;

        &::after {
            font-family: 'icomoon';
            speak: never;
            font-style: normal;
            font-weight: normal;
            font-variant: normal;
            text-transform: none;
            line-height: 1;
            -webkit-font-smoothing: antialiased;
            -moz-osx-font-smoothing: grayscale;
            content: '\\e917';
            font-size: 2.5rem;
        }
    `
        : ``};
    background-color: ${isNewsletter
        ? `transparent`
        : theme.buttonBackgroundColor.yellow.color};
    color: ${isNewsletter ? theme.palette.lightBlue : theme.palette.black};
    display: ${isNewsletter ? `block` : `inline-flex`};
    align-items: center;
    justify-content: center;
    text-align: center;
    font-size: ${isNewsletter ? `0` : `2rem`};
    line-height: ${isNewsletter ? `normal` : `1`};
    font-weight: 900;
    padding: ${isNewsletter ? `8px` : `18px 25px`};
    cursor: pointer;
    ${transition({}, "background-color")};

    &:hover,
    &:focus {
        background-color: ${isNewsletter
            ? `transparent`
            : theme.buttonBackgroundColor.yellow.hover};
    }

    @media (min-width: ${theme.breakpoints.mobileLandscape}) {
        padding: ${isNewsletter ? `18px 15px` : `18px 25px`};
        border-left: ${isNewsletter
            ? `1px solid ${theme.palette.white}`
            : `none`};
    }
`;
